import { kebabCase } from 'lodash';
import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import AssetSelectionModal from './asset/assetSelectionModal';
import entityComposition from '../../common/classes/entityComposition';
import TextField from './textField';
import { labelSelector, valueSelector } from '../selectors';
import logValueOnChange from '../commonActions/logValueOnChange';
const AssetPickerField = ({
  label: _label = '',
  onChange,
  value: _value = {
    title: ''
  }
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleSelect = useCallback((...changes) => {
    onChange(...changes);
    setIsModalOpen(false);
  }, [onChange]);
  const toggleModal = () => setIsModalOpen(!isModalOpen);
  const textFieldID = `input-${kebabCase(_label)}`; // matches textField implementation
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextField, {
    enabled: false,
    format: {
      label: _label
    } // format.label read by labelSelector. Could change to accept props.label
    ,
    value: _value.title,
    onChange: () => {},
    onFocus: toggleModal
  }), /*#__PURE__*/React.createElement(AssetSelectionModal, {
    isOpen: isModalOpen,
    onToggle: toggleModal,
    onSelect: handleSelect,
    targetElementID: textFieldID
  }));
};
AssetPickerField.propTypes = {
  label: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.shape({
    id: PropTypes.string,
    title: PropTypes.string
  })
};
export { AssetPickerField as UncomposedAssetPickerField };
export default entityComposition(AssetPickerField, [], {
  label: labelSelector,
  value: valueSelector,
  onChange: logValueOnChange
});